import { Vector as VectorLayer } from "ol/layer";
import { Vector as VectorSource } from "ol/source";
import { Stroke, Style } from "ol/style";
import { vaylaAttributions } from "../hooks/useCreateMapLayers";
import { LayerTitle } from "../types/layers";
import { createLayer } from "./createLayer";

interface Return {
  source: VectorSource;
  layer: VectorLayer;
}

function createFairwayLayer(): Return {
  const layer = createLayer({
    source: new VectorSource({
      attributions: [vaylaAttributions],
    }),
    title: LayerTitle.Fairways,
    layer: new VectorLayer({
      style: new Style({
        stroke: new Stroke({
          color: "rgba(0, 0, 0, 0.6)",
          width: 2,
        }),
      }),
    }),
  }) as VectorLayer;
  const source = layer.getSource();
  return { source, layer };
}

export default createFairwayLayer;
